var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ position: 'relative', width: _vm.width })},[(_vm.showRed)?_c('span',{staticClass:"form-red-star"},[_vm._v("*")]):_vm._e(),_vm._t("default",[_c('span')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }